export default "__VITE_ASSET__glue7V8K__"